module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/node_modules/sockjs-client/lib/transport/browser/eventsource.js
// module id = ../../../../sockjs-client/lib/transport/browser/eventsource.js
// module chunks = vendor